module.exports = __webpack_public_path__ + "static/media/baazar.bfc12318.png";